export const ROW_HEIGHT = 40

export const getBigger = (a, b) => a > b ? a : b

export const InsertBetweenArray = (array, index, data) => [
  ...array.slice(0, index),
  ...data,
  ...array.slice(index),
]

export const getOuterRange = (array, a, b) => {
  return {
    outer: [
      ...array.slice(0, a),
      ...array.slice(b),
    ],
    inner: array.slice(a, b),
  }
}

export const getCellId = (index) => `cell-${index}`
export const getCellIndex = (cellId) => cellId.split('-').slice(1).join('-')
export const getCell = (location) => getCellInput(location).parentElement
export const getCellInput = (location) => document.getElementById(getCellId(location))

export const getScrollbarSize = () => {
  // Creating invisible container
  const outer = document.createElement('div')
  outer.style.visibility = 'hidden'
  outer.style.overflow = 'scroll' // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar' // needed for WinJS apps
  document.body.appendChild(outer)

  // Creating inner element and placing it in the container
  const inner = document.createElement('div')
  outer.appendChild(inner)

  // Calculating difference between container's full width and the child width
  const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth)
  const scrollbarHeight = (outer.offsetHeight - inner.offsetHeight)

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer)

  return { scrollbarWidth, scrollbarHeight }
}

export const getDatumLocation = (datum) => datum.data.location
export const getDataLocations = (data) => data.map(datum => getDatumLocation(datum))